import Vue from 'vue'
import AscMxStatusIconLabel from '@/components/atoms/AscMxStatusIconLabel'

export default Vue.extend({
  components: {
    AscMxStatusIconLabel,
  },

  data: function () {
    return {}
  },

  computed: {
    getStatusName() {
      return this.params.data.statusName
    },
  },

  template: `<asc-mx-status-icon-label 
  :status-name="getStatusName"/>`,
})
